import { render, staticRenderFns } from "./TaskSurveyForm.vue?vue&type=template&id=285f8c53&scoped=true"
import script from "./TaskSurveyForm.vue?vue&type=script&lang=js"
export * from "./TaskSurveyForm.vue?vue&type=script&lang=js"
import style0 from "./TaskSurveyForm.vue?vue&type=style&index=0&id=285f8c53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f8c53",
  null
  
)

export default component.exports